import TextEditingPanelContainer from './TextEditingPanelContainer';

export default TextEditingPanelContainer;
